/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAdminDocumentIndexCountDto } from '../models/work-admin-document-index-count-dto';
import { WorkAdminDocumentIndexStatusDtoEvent } from '../models/work-admin-document-index-status-dto-event';
import { WorkAdminMissingDocumentsPageDto } from '../models/work-admin-missing-documents-page-dto';

@Injectable({ providedIn: 'root' })
export class WorkAdminDocumentIndexService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminDocumentIndexControllerListenToStatus()` */
  static readonly AdminDocumentIndexControllerListenToStatusPath = '/v2/admin/document-index/status';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentIndexControllerListenToStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerListenToStatus$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminDocumentIndexStatusDtoEvent>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDocumentIndexService.AdminDocumentIndexControllerListenToStatusPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: 'text/event-stream', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminDocumentIndexStatusDtoEvent>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentIndexControllerListenToStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerListenToStatus(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAdminDocumentIndexStatusDtoEvent> {
    return this.adminDocumentIndexControllerListenToStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminDocumentIndexStatusDtoEvent>): WorkAdminDocumentIndexStatusDtoEvent => r.body)
    );
  }

  /** Path part for operation `adminDocumentIndexControllerGetMissingCount()` */
  static readonly AdminDocumentIndexControllerGetMissingCountPath = '/v2/admin/document-index/missing-count';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentIndexControllerGetMissingCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerGetMissingCount$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminDocumentIndexCountDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDocumentIndexService.AdminDocumentIndexControllerGetMissingCountPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminDocumentIndexCountDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentIndexControllerGetMissingCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerGetMissingCount(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAdminDocumentIndexCountDto> {
    return this.adminDocumentIndexControllerGetMissingCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminDocumentIndexCountDto>): WorkAdminDocumentIndexCountDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentIndexControllerGetMissingDocuments()` */
  static readonly AdminDocumentIndexControllerGetMissingDocumentsPath = '/v2/admin/document-index/missing-documents';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentIndexControllerGetMissingDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerGetMissingDocuments$Response(
    params?: {
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminMissingDocumentsPageDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDocumentIndexService.AdminDocumentIndexControllerGetMissingDocumentsPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminMissingDocumentsPageDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentIndexControllerGetMissingDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerGetMissingDocuments(
    params?: {
      page?: number;
      limit?: number;
    },
    context?: HttpContext
  ): Observable<WorkAdminMissingDocumentsPageDto> {
    return this.adminDocumentIndexControllerGetMissingDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminMissingDocumentsPageDto>): WorkAdminMissingDocumentsPageDto => r.body)
    );
  }

  /** Path part for operation `adminDocumentIndexControllerRecheckMissing()` */
  static readonly AdminDocumentIndexControllerRecheckMissingPath = '/v2/admin/document-index/recheck-missing';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentIndexControllerRecheckMissing()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerRecheckMissing$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDocumentIndexService.AdminDocumentIndexControllerRecheckMissingPath, 'patch');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentIndexControllerRecheckMissing$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerRecheckMissing(
    params?: {
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminDocumentIndexControllerRecheckMissing$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `adminDocumentIndexControllerDeleteDocument()` */
  static readonly AdminDocumentIndexControllerDeleteDocumentPath = '/v2/admin/document-index/document/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminDocumentIndexControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerDeleteDocument$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminDocumentIndexService.AdminDocumentIndexControllerDeleteDocumentPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminDocumentIndexControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminDocumentIndexControllerDeleteDocument(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminDocumentIndexControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
